// extracted by mini-css-extract-plugin
export default {"ChangePassword":"ChangePassword_ChangePassword__InwNO"};